import * as XLSX from "xlsx-js-style";
import { APIURL } from "../../../configApi/apiConfig";
import axios from "../../../configApi/axiosConfig";

const ESTADOS_SOLICITUD_BADGE = {
  1: { etiqueta: "PRE-APROBADO" },
  2: { etiqueta: "APROBADO" },
  4: { etiqueta: "RECHAZADO" },
  6: { etiqueta: "FACTURADO" },
};

export const generarReporteExcelConversion = async ({
  filas,
  totalFila,
  titulo,
  fechaConsultaInicio,
  fechaConsultaFin
}) => {
  if (!filas || filas.length === 0) return;

  const ws_data = [];
  const ws_rows = [];
  const formatConv = (datos) => `${datos?.conversion ?? 0}%`;

  ws_data.push([
    "Región / Supervisor / Bodega / Vendedor",
    "Consulta Cédulas",
    "Pre-aprobadas",
    "Gestionadas",
    "Rechazadas",
    "Facturados",
    "Conversión (Consultas)",
    "Consultas Pre-aprobadas"
  ]);
  ws_rows.push({ level: 0 });

  const agregarSolicitudes = async (idVendedor, datosIndicadores, offsetNivel = 0) => {
    let solicitudes = [];
    if (idVendedor && datosIndicadores?.solicitudesGestionadas > 0) {
      try {
        const { data } = await axios.get(
          APIURL.get_solicitudesGestionadasConversionPerfil(idVendedor, fechaConsultaInicio, fechaConsultaFin)
        );
        if (Array.isArray(data) && data.length > 0) {
          solicitudes = data;
        }
      } catch (err) {
        console.error("Error obteniendo solicitudes exportación:", err);
      }
    }

    if (solicitudes.length > 0) {
      ws_data.push(["", "CÉDULA", "CLIENTE", "PRODUCTO", "FECHA", "ESTADO"]);
      ws_rows.push({ level: 4 + offsetNivel, hidden: true, isSubHeader: true });

      solicitudes.forEach((sol) => {
        const estadoBadge = ESTADOS_SOLICITUD_BADGE[sol.estado]?.etiqueta || "—";
        ws_data.push([
          "",
          sol.cedula || "—",
          sol.cliente || "—",
          sol.producto || "—",
          sol.fecha?.substring?.(0, 10) || "—",
          estadoBadge
        ]);
        ws_rows.push({ level: 4 + offsetNivel, hidden: true, isData: true });
      });
    }
  };

  for (const region of filas) {
    ws_data.push([
      region.etiqueta,
      region.datos?.consultaCedulas || 0,
      region.datos?.preAprobadas || 0,
      region.datos?.solicitudesGestionadas || 0,
      region.datos?.rechazadas || 0,
      region.datos?.facturados || 0,
      formatConv(region.datos),
      formatConv({ conversion: region.datos?.conversionPreAprobadas })
    ]);
    ws_rows.push({ level: 0, hidden: false, isRegion: true });

    if (region.supervisores && region.supervisores.length > 0) {
      for (const supervisor of region.supervisores) {
        const esSubWeb = supervisor.etiqueta === "COMPU FERIA" || supervisor.etiqueta === "POINT WEB";
        const offsetNivel = esSubWeb ? 1 : 0;

        ws_data.push([
          supervisor.etiqueta,
          supervisor.datos?.consultaCedulas || 0,
          supervisor.datos?.preAprobadas || 0,
          supervisor.datos?.solicitudesGestionadas || 0,
          supervisor.datos?.rechazadas || 0,
          supervisor.datos?.facturados || 0,
          formatConv(supervisor.datos),
          formatConv({ conversion: supervisor.datos?.conversionPreAprobadas })
        ]);
        ws_rows.push({ level: 1 + offsetNivel, hidden: true, isSupervisor: true });

        if (supervisor.bodegas && supervisor.bodegas.length > 0) {
          for (const bodega of supervisor.bodegas) {
            ws_data.push([
              bodega.etiqueta,
              bodega.datos?.consultaCedulas || 0,
              bodega.datos?.preAprobadas || 0,
              bodega.datos?.solicitudesGestionadas || 0,
              bodega.datos?.rechazadas || 0,
              bodega.datos?.facturados || 0,
              formatConv(bodega.datos),
              formatConv({ conversion: bodega.datos?.conversionPreAprobadas })
            ]);
            ws_rows.push({ level: 2 + offsetNivel, hidden: true, isBodega: true });

            if (bodega.vendedores && bodega.vendedores.length > 0) {
              for (const vendedor of bodega.vendedores) {
                ws_data.push([
                  vendedor.etiqueta,
                  vendedor.datos?.consultaCedulas || 0,
                  vendedor.datos?.preAprobadas || 0,
                  vendedor.datos?.solicitudesGestionadas || 0,
                  vendedor.datos?.rechazadas || 0,
                  vendedor.datos?.facturados || 0,
                  formatConv(vendedor.datos),
                  formatConv({ conversion: vendedor.datos?.conversionPreAprobadas })
                ]);
                ws_rows.push({ level: 3 + offsetNivel, hidden: true, isVendedor: true });
                await agregarSolicitudes(vendedor.idVendedor, vendedor.datos, offsetNivel);
              }
            } else {
              await agregarSolicitudes(null, bodega.datos, offsetNivel);
            }
          }
        } else {
          await agregarSolicitudes(null, supervisor.datos, offsetNivel);
        }
      }
    } else {
      await agregarSolicitudes(region.idVendedor, region.datos);
    }
  }

  if (totalFila) {
    ws_data.push([
      "TOTAL",
      totalFila.consultaCedulas || 0,
      totalFila.preAprobadas || 0,
      totalFila.solicitudesGestionadas || 0,
      totalFila.rechazadas || 0,
      totalFila.facturados || 0,
      formatConv(totalFila),
      formatConv({ conversion: totalFila.conversionPreAprobadas })
    ]);
    ws_rows.push({ level: 0, hidden: false, isTotal: true });
  }

  const ws = XLSX.utils.aoa_to_sheet(ws_data);
  ws['!outline'] = { above: true };
  ws['!rows'] = ws_rows.map(r => ({ level: r.level, hidden: r.hidden }));

  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    const rowMeta = ws_rows[R];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cell_address = { c: C, r: R };
      const cell_ref = XLSX.utils.encode_cell(cell_address);
      if (!ws[cell_ref]) continue;

      ws[cell_ref].s = {
        alignment: { vertical: "center", horizontal: "center" },
        border: {
          top: { style: "thin", color: { auto: 1 } },
          bottom: { style: "thin", color: { auto: 1 } },
          left: { style: "thin", color: { auto: 1 } },
          right: { style: "thin", color: { auto: 1 } }
        }
      };

      if (R === 0) {
        ws[cell_ref].s.font = { bold: true };
        if (C === 0) {
          ws[cell_ref].s.fill = { fgColor: { rgb: "2563EB" } };
          ws[cell_ref].s.font.color = { rgb: "FFFFFF" };
        } else if (C === 1) {
          ws[cell_ref].s.fill = { fgColor: { rgb: "FFFFFF" } };
          ws[cell_ref].s.font.color = { rgb: "1E3A8A" };
        } else if (C === 2) {
          ws[cell_ref].s.fill = { fgColor: { rgb: "FFFFFF" } };
          ws[cell_ref].s.font.color = { rgb: "1E3A8A" };
        } else if (C === 3) {
          ws[cell_ref].s.fill = { fgColor: { rgb: "FDE047" } };
          ws[cell_ref].s.font.color = { rgb: "1E3A8A" };
        } else if (C === 4) {
          ws[cell_ref].s.fill = { fgColor: { rgb: "FFFFFF" } };
          ws[cell_ref].s.font.color = { rgb: "1E3A8A" };
        } else if (C === 5) {
          ws[cell_ref].s.fill = { fgColor: { rgb: "4ADE80" } };
          ws[cell_ref].s.font.color = { rgb: "1E3A8A" };
        } else if (C === 6 || C === 7) {
          ws[cell_ref].s.fill = { fgColor: { rgb: "D1D5DB" } };
          ws[cell_ref].s.font.color = { rgb: "1E3A8A" };
        }
      } else if (rowMeta.isSubHeader) {
        ws[cell_ref].s.fill = { fgColor: { rgb: "F3F4F6" } };
        ws[cell_ref].s.font = { bold: true, color: { rgb: "374151" } };
        if (C > 0) ws[cell_ref].s.alignment.horizontal = "left";
      } else if (rowMeta.isData) {
        if (C > 0) ws[cell_ref].s.alignment.horizontal = "left";
        if (C === 5) ws[cell_ref].s.font = { bold: true, color: { rgb: "4B5563" } };
      } else {
        if (C === 0) {
          ws[cell_ref].s.alignment.horizontal = "left";
          if (rowMeta.level === 1) ws[cell_ref].s.alignment.indent = 2;
          if (rowMeta.level === 2) ws[cell_ref].s.alignment.indent = 4;
          if (rowMeta.level === 3) ws[cell_ref].s.alignment.indent = 6;
          if (rowMeta.level === 4 && !rowMeta.isSubHeader && !rowMeta.isData) ws[cell_ref].s.alignment.indent = 8;
          if (rowMeta.level === 5 && !rowMeta.isSubHeader && !rowMeta.isData) ws[cell_ref].s.alignment.indent = 10;

          if (rowMeta.isRegion || rowMeta.isTotal) {
            ws[cell_ref].s.font = { bold: true, color: { rgb: "1E3A8A" } };
          } else if (rowMeta.isSupervisor) {
            ws[cell_ref].s.font = { bold: true, color: { rgb: "1E3A8A" } };
          } else if (rowMeta.isBodega) {
            ws[cell_ref].s.font = { bold: true, color: { rgb: "1E3A8A" } };
          } else {
            ws[cell_ref].s.font = { color: { rgb: "000000" } };
          }
        }

        if ((rowMeta.isRegion || rowMeta.isTotal) && C <= 7) {
          ws[cell_ref].s.fill = { fgColor: { rgb: "EFF6FF" } };
        }

        if (C === 6 || C === 7) {
          const val = parseFloat(ws[cell_ref].v);
          if (!isNaN(val)) {
            if (val >= 80) {
              ws[cell_ref].s.fill = { fgColor: { rgb: "D1FAE5" } };
              ws[cell_ref].s.font = { color: { rgb: "047857" }, bold: true };
            } else if (val >= 60) {
              ws[cell_ref].s.fill = { fgColor: { rgb: "DBEAFE" } };
              ws[cell_ref].s.font = { color: { rgb: "1D4ED8" }, bold: true };
            } else if (val >= 40) {
              ws[cell_ref].s.fill = { fgColor: { rgb: "FEF3C7" } };
              ws[cell_ref].s.font = { color: { rgb: "B45309" }, bold: true };
            } else if (val >= 20) {
              ws[cell_ref].s.fill = { fgColor: { rgb: "FFEDD5" } };
              ws[cell_ref].s.font = { color: { rgb: "C2410C" }, bold: true };
            } else {
              ws[cell_ref].s.fill = { fgColor: { rgb: "FFE4E6" } };
              ws[cell_ref].s.font = { color: { rgb: "BE123C" }, bold: true };
            }
          }
        }
      }
    }
  }

  ws['!cols'] = [
    { wch: 35 },
    { wch: 18 },
    { wch: 35 },
    { wch: 22 },
    { wch: 15 },
    { wch: 18 },
    { wch: 25 },
    { wch: 28 }
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Datos");
  XLSX.writeFile(wb, `${titulo}.xlsx`);
};
